import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { useIframeCommunicationChannel } from './useIframeCommunicationChannel';
import { useHostOffsetOverride } from './useHostOffsetOverride';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const StyledIframe = styled.iframe({
  border: 'none',
  width: '100%',
  height: '100%'
});
export const Iframe = ({
  src,
  onLoad,
  onUnload,
  onContentLoadStarted,
  ...passThroughProps
}) => {
  useEffect(() => {
    const handler = e => {
      if (e.data.type === 'windowUnload') {
        onUnload === null || onUnload === void 0 ? void 0 : onUnload();
      }
    };
    window.addEventListener('message', handler);
    return () => {
      window.removeEventListener('message', handler);
    };
  }, [onUnload]);
  useHostOffsetOverride();
  const channel = useIframeCommunicationChannel(src, {
    ...passThroughProps,
    onContentLoadStarted
  });
  return /*#__PURE__*/React.createElement(StyledIframe, _extends({
    title: "confluence-article-iframe",
    "data-testid": "confluence-page-iframe",
    name: channel.name,
    src: src,
    onLoad: onLoad
    // Grant features to iframe (Currently the same as smart card iframe's granted features)
    ,
    allow: "autoplay; fullscreen; encrypted-media; clipboard-write"
    // Same as "fullscreen" in "allow" attribute but it's considered a legacy attribute. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#attr-allowfullscreen
    // Need it in case the browser doesn't support "fullscreen" feature policy.
    ,
    allowFullScreen: true
  }, passThroughProps));
};